<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain class="" max-height="14vh" max-width="26vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">افزودن دارو</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n13 mt-2">
              <v-btn class="mx-2 mr-n16" fab dark small @click="backToDrugPage()" color="darkColor" elevation="0">
                <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card height="79vh" elevation="0" class="body-card card-width">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <v-row>
                        <span>اطلاعات دارو</span>
                        <v-divider class="mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row>
                        <v-col cols="4">
                          <v-text-field label="عنوان*" outlined dense v-model="drug.title"
                            prepend-inner-icon="mdi-pill mdi-18px" clearable v-on:keyup.enter="enableAddEdit()"
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field label="کد" outlined dense v-model="drug.code"
                            prepend-inner-icon="mdi-barcode mdi-18px" clearable v-on:keyup.enter="enableAddEdit()"
                            clear-icon="mdi-close-circle-outline"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete :items="allDrugGroupsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                            outlined item-text="title" item-value="id" v-model="drug.drugGroupId" label="گروه دارو"
                            autocomplete="off" clearable clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-pill-multiple mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="mt-n7">
                          <v-autocomplete :items="allUnitsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                            item-text="title" item-value="id" v-model="drug.unitId" label="واحد دارو" autocomplete="off"
                            clearable clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-medication mdi-18px"></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="mt-n7">
                          <v-autocomplete :items="allOrderTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                            outlined item-text="title" multiple chips small-chips item-value="id"
                            v-model="drug.orderTypeIds" label="نحوه تجویز" autocomplete="off" clearable
                            clear-icon="mdi-close-circle-outline"
                            prepend-inner-icon="mdi-needle mdi-18px"></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row class="mt-n5">
                        <span>دوزاژ</span>
                        <v-divider class="mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea outlined label="بیمار  11 سال و کمتر"
                            prepend-inner-icon="mdi-medical-cotton-swab mdi-18px" clearable
                            v-model="drug.dosageNoteForLessThan11" rows="4" v-on:keyup.enter="enableAddEdit()"
                            clear-icon="mdi-close-circle-outline"></v-textarea>
                        </v-col>
                        <v-col cols="12" class="mt-n7">
                          <v-textarea outlined label="بیمار بالای 11 سال"
                            prepend-inner-icon="mdi-medical-cotton-swab mdi-18px" clearable
                            v-on:keyup.enter="enableAddEdit()" rows="4" v-model="drug.dosageNoteForMoreThan11"
                            clear-icon="mdi-close-circle-outline"></v-textarea>
                        </v-col>
                      </v-row>
                      <v-row class="mt-n5">
                        <span>کانتراندیکاسیون ها</span>
                        <v-divider class="mt-2 mr-3"></v-divider>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <v-textarea outlined label="کانتراندیکاسیون ها"
                            prepend-inner-icon="mdi-clipboard-pulse mdi-18px" clearable
                            v-on:keyup.enter="enableAddEdit()" v-model="drug.contraindication" rows="4"
                            clear-icon="mdi-close-circle-outline"></v-textarea>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="2">
                          <v-btn rounded color="darkColor" block dark @click="enableAddEdit()"
                            class="normal-letter-spacing">
                            ثبت
                          </v-btn>
                        </v-col>
                        <v-col cols="2" class="ml-1">
                          <v-btn outlined rounded block color="darkColor" class="normal-letter-spacing"
                            @click="backToDrugPage()">
                            انصراف
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import AlertComponent from '../../../components/AlertComponent.vue';
import confirmDialog from '../../../components/ConfirmDialog.vue';

import snackBar from '@/Mixins/snackBar.js';
import sharedHelper from '@/Helpers/Shared';
import ShearedMixin from '@/Mixins/Shared.js';
import AddDrug from '@/Helpers/BaseInformation/Drug/AddDrugHelper.js';
import DrugMixin from '@/Mixins/BaseInformation/DrugMixin';
import UnitMixin from '@/Mixins/BaseInformation/UnitMixin';
import OrderTypeMixin from '@/Mixins/BaseInformation/OrderTypeMixin';
import DrugGroupMixin from '@/Mixins/BaseInformation/DrugGroupMixin';
export default {
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    confirmDialog,
  },
  mixins: [
    ShearedMixin,
    sharedHelper,
    snackBar,
    AddDrug,
    UnitMixin,
    DrugGroupMixin,
    OrderTypeMixin,
    DrugMixin,
  ],
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      //tableTitleIMG: require("@/assets/images/tableTitleIMG.png"),
      //table: require("@/assets/images/table.png"),
    };
  },
  methods: {
    mounte: function () {
      if (this.$route.params.id) {
        this.getDrugFunction(Number(this.$route.params.id));
      }
      this.getListOfUnits();
      this.getListOfOrderTypes();
      this.getListOfDrugGroupsForOther();
    },
  },
};
</script>
<style scoped>
.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
